<template>
  <nav class="flex items-center mb-8 flex-wrap overflow-x-auto" aria-label="Progress">
    <ol class="flex items-center flex-wrap w-full">
      <li
        v-for="(label, idx) in steps"
        :key="getStepKey(label, idx)"
        class="flex items-center min-w-max whitespace-nowrap mb-2"
      >
        <div
          :class="[
            'rounded-full h-10 w-10 flex items-center justify-center font-bold transition-colors',
            isCurrent(idx) ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'
          ]"
          :aria-current="isCurrent(idx) ? 'step' : null"
        >
          {{ idx + 1 }}
        </div>
        <div
          :class="[
            'ml-2 mr-4 font-semibold transition-colors',
            isCurrent(idx) ? 'text-blue-600' : 'text-gray-600'
          ]"
        >
          {{ label }}
        </div>
        <div
          v-if="idx < steps.length - 1"
          class="w-8 h-1 bg-gray-300 mx-2 hidden sm:block"
          aria-hidden="true"
        ></div>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'ReoptStepper',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      required: true
    }
  },
  methods: {
    isCurrent(idx) {
      return this.currentStep === idx + 1;
    },
    getStepKey(label, idx) {
      // Allows for custom string step names without duplicate keys
      return typeof label === "string" ? `${idx}-${label}` : idx;
    }
  }
}
</script>
